/**
 * Validates if a field has a value (not empty or just whitespace)
 */
export const validateRequired = (value: string): boolean => {
  return value.trim().length > 0;
};

/**
 * Validates email format using a simple regex
 */
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

/**
 * Validates minimum length
 */
export const validateMinLength = (value: string, minLength: number): boolean => {
  return value.trim().length >= minLength;
};

/**
 * Validates maximum length
 */
export const validateMaxLength = (value: string, maxLength: number): boolean => {
  return value.trim().length <= maxLength;
};

/**
 * Validates that an ISO date string (YYYY-MM-DD) is not earlier than minDate.
 * Empty values pass, so the required check owns the "missing value" message.
 */
export const validateMinDate = (value: string, minDate: string): boolean => {
  const date = value.trim();
  if (date.length === 0) {
    return true;
  }
  return date >= minDate;
};

/**
 * Sanitizes input by removing potentially harmful characters
 */
export const sanitizeInput = (input: string): string => {
  return input.trim().replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
};
